export const VoicemailMessageType = {
  CONTENT_AND_CALLBACK: 'callbackandmessage',
  CONTENT: 'messageonly',
  CALLBACK: 'callbackonly',
  HANG_UP: 'hangup',
};

export const VoicemailMessageTypeStringId = {
  [VoicemailMessageType.CONTENT_AND_CALLBACK]:
    'MESSAGE_TYPE_CALLBACK_AND_MESSAGE',
  [VoicemailMessageType.CONTENT]: 'MESSAGE_TYPE_MESSAGE_ONLY',
  [VoicemailMessageType.CALLBACK]: 'MESSAGE_TYPE_CALLBACK_ONLY',
  [VoicemailMessageType.HANG_UP]: 'MESSAGE_TYPE_HANGUP',
};
